import { render } from "./video.vue?vue&type=template&id=a7b7b3a2&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=a7b7b3a2&lang=less&scoped=true"
import "./video.vue?vue&type=style&index=1&id=a7b7b3a2&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7b7b3a2"]])

export default __exports__